import * as CONSTANTS from "./constants";

const initialState = {
  loading: false,
  //loadingMessage:'Please wait...'
  currentModel: "",
  selectedEvent: null,
  isVerifyShow: false,
  userId: "",
  categories: [],
  events: [],
  roles: [],
  activeRole: null,
  swallowEO:"",
};

const adminStore = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_LOADING_TRUE:
      return {
        ...state,
        loading: true,
        //loadingMessage:action.payload ? action.payload : 'Please wait...'
      };
    case CONSTANTS.SET_LOADING_FALSE:
      return {
        ...state,
        loading: false,
        //loadingMessage:''
      };
    case CONSTANTS.GET_EVENT_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      };
    case CONSTANTS.GET_EVENTS_BY_CATEGORY:
      return {
        ...state,
        events: action.events,
      };
    case CONSTANTS.SET_CURRENT_MODAL:
      return {
        ...state,
        currentModel: action.payload,
      };
    case CONSTANTS.SET_SELECTED_EVENT:
      return {
        ...state,
        selectedEvent: action.payload,
      };
    case CONSTANTS.GET_ALL_USER_ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case CONSTANTS.SET_ACTIVE_ROLE:
      return {
        ...state,
        activeRole: action.payload,
      };
    case CONSTANTS.VERIFY_MODAL_TOGGLE:
      return {
        ...state,
        isVerifyShow: action.payload.value,
        userId: action.payload.userId,
      };      
       case CONSTANTS.SET_SWALLOW_EO:
      return {
        ...state,
        swallowEO: action.payload,
      };
    default:
      return state;
  }
};

export default adminStore;
